<template>
    <div class="partner_offer_card__container flex flex-column justify-content-between w-full h-full p-3">
        <div class="w-full">
            <div class="partner_offer_card__img_container flex align-items-center justify-content-center w-full">
                <img v-if="item.img.length" class="max-w-full" :src="PartnerOffers.IMG_PATH + item.img" />
            </div>
            <p v-html="item.description"></p>
        </div>
        <div class="w-full">
            <div class="flex justify-content-center">
                <Button
                    :label="$t('lang.pages.partner_offers.button_link')"
                    class="w-full sm:w-auto"
                    size="small"
                    @click="onClickLink"
                />
            </div>
            <Divider />
            <div class="flex flex-column gap-3 align-items-center">
                <div v-if="!isUserAuthenticated" class="flex flex-column gap-2 w-full">
                    <span class="text-center font-bold" v-html="$t('lang.pages.partner_offers.auth_required')"></span>
                    <div class="flex justify-content-between align-items-center w-full gap-3 flex-wrap sm:flex-nowrap">
                        <Button
                            text
                            :label="$t('lang.pages.partner_offers.button_register')"
                            class="w-full sm:w-auto"
                            size="small"
                            @click="onClickRegister"
                        />
                        <Button
                            text
                            :label="$t('lang.pages.partner_offers.button_login')"
                            class="w-full sm:w-auto"
                            size="small"
                            @click="onClickLogin"
                        />
                    </div>
                </div>
                <span v-else v-html="item.promo"></span>
            </div>
        </div>
    </div>
</template>

<script>
import Button from "primevue/button";
import Divider from "primevue/divider";
import {PartnerOffers} from "../constants/PartnerOffers";

export default {
    name: "PartnerOfferCard",
    props: {
        item: {
            type: Object,
            required: true,
        }
    },
    computed: {
        PartnerOffers() {
            return PartnerOffers;
        },
        isUserAuthenticated() {
            return this.$store.getters.IS_USER_AUTHENTICATED;
        },
    },
    methods: {
        onClickLink() {
            window.open(this.item.link);
        },
        onClickRegister() {
            window.open(sprintf('/%s/registration', window.locale), '_self');
        },
        onClickLogin() {
            window.open(sprintf('/%1$s/login?redirect=/%1$s/partner_offers', window.locale), '_self');
        },
    },
    components: {
        Button,
        Divider,
    }
}
</script>

<style scoped>
.partner_offer_card__container {
    border-radius: var(--border-radius);
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
}
.partner_offer_card__img_container {
    aspect-ratio: 1 / 1;
    max-height: 300px;
}
.partner_offer_card__img_container img {
    max-height: 250px;
}
</style>
